module.exports = __webpack_public_path__ + "static/img/wyfw3.91a3934.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfw3.png
// module id = JA4t
// module chunks = 1